import Vue from 'vue'


const actions = {

    getProductsFromApi: ({commit,rootGetters,state}, payload) => {


        return PORTAL_API.get("/companies/" + rootGetters.profile.company.id + "/products").then(res => {
            if (res.status === 200) {
                commit('setProducts', res.data)
            return res.data
            }
        }).catch(err => {
            return err;
        });
    },

    createProduct: ({state,rootGetters}, payload) => {
        return PORTAL_API.put("/companies/" + rootGetters.profile.company.id + "/products" , payload).then(res => {
            if (res.status === 201) {
                Vue.toasted.global.successRequest({
                    message: 'Product aangemaakt'
                });
                return true
            }
        }).catch(err => {
            Vue.toasted.global.failedRequest();
            return err
        });
    },

    editProduct: ({state, dispatch,rootGetters}, payload) => {
        return PORTAL_API.put('/companies/'  + rootGetters.profile.company.id + '/products/' + payload.id, payload).then(res => {
            if (res.status === 200) {
                dispatch('getProductsFromApi');
                Vue.toasted.global.successRequest({
                    message: 'Product aangepast'
                });
                return true
            }
        }).catch(err => {
            Vue.toasted.global.failedRequest();

            return err
        });
    },
    deleteProduct: ({dispatch,rootGetters}, payload) => {
        Vue.toasted.info('Weet je zeker dat je dit product wilt verwijderen', {
            icon: 'trash',
            iconPack: 'fontawesome',
            className: 'mToasted',
            action: [
                {
                    text: 'Ja, ik weet het zeker.',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                        PORTAL_API.delete('/companies/'  + rootGetters.profile.company.id + '/products/' + payload).then((res) => {
                            if (res.status === 200) {
                                dispatch('getProductsFromApi');
                                Vue.toasted.global.successRequest({
                                    message: 'Product verwijderd'
                                })
                            } else {
                                Vue.toasted.global.failedRequest({})
                            }
                        }).catch(e => {
                            Vue.toasted.global.failedRequest({})
                        })
                    }
                },
                {
                    text: 'Annuleren',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }
            ]
        })
    },
    getAttributesFromApi: ({commit,rootGetters}) => {
      return   PORTAL_API.get('/companies/'  + rootGetters.profile.company.id + '/attributes-field-definition').then(res => {
            if (res.status === 200) {
                commit('setAttributes', res.data)
                return res.data
            }
        }).catch(err => {
            return err
        });
    },
    postAttributeOrder: ({state,rootGetters}) => {
        PORTAL_API.put('/companies/' + rootGetters.profile.company.id + '/attributes-field-definition-order', state.attributes).then(res => {
        }).catch(err => {
            return err
        });
    },

    createAttributeApi: ({dispatch,rootGetters}, payload) => {
        return PORTAL_API.put('/companies/'  + rootGetters.profile.company.id + '/attributes-field-definition', payload).then(res => {
            if (res.status === 201) {
                dispatch('getAttributesFromApi');
                Vue.toasted.global.successRequest({message: 'Attribuut aangemaakt'});
            }
        }).catch(err => {
            return err
        });
    },
    saveAttribute: ({dispatch,rootGetters}, payload) => {
        return PORTAL_API.put('/companies/' + rootGetters.profile.company.id + '/attributes-field-definition/' + payload.id, payload).then(res => {
            if (res.status === 200) {
                dispatch('getAttributesFromApi');
                Vue.toasted.global.successRequest({message: 'Attribuut aangepast'});
            }
        }).catch(err => {
            return err
        });
    },
    deleteAttribute: ({dispatch,rootGetters}, payload) => {
        Vue.toasted.info('Weet je zeker dat je deze attribuut wilt verwijderen', {
            icon: 'trash',
            iconPack: 'fontawesome',
            className: 'mToasted',
            action: [
                {
                    text: 'Ja, ik weet het zeker.',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                        PORTAL_API.delete('/companies/' + rootGetters.profile.company.id + '/attributes-field-definition/' + payload).then((res) => {
                            if (res.status === 200) {
                                dispatch('getAttributesFromApi');
                                Vue.toasted.global.successRequest({
                                    message: 'Attribuut verwijderd'
                                })
                            } else {
                                Vue.toasted.global.failedRequest({})
                            }
                        }).catch(e => {
                            Vue.toasted.global.failedRequest({})
                        })
                    }
                },
                {
                    text: 'Annuleren',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }
            ]
        })
    },
}
export default actions